import { render, staticRenderFns } from "./viewRosterShifts.vue?vue&type=template&id=0f7dc032&"
import script from "./viewRosterShifts.vue?vue&type=script&lang=js&"
export * from "./viewRosterShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports